import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from '../cx';

export type PageContainerWidth = 'prose' | 'default' | 'wide';

export type PageContainerProps = HTMLAttributes<HTMLElement> & {
  as?: 'div' | 'main' | 'section' | 'header' | 'footer';
  /** prose: reading pages; default: most pages; wide: search results, maps, dashboards. */
  width?: PageContainerWidth;
  children: ReactNode;
};

const WIDTH: Record<PageContainerWidth, string> = {
  prose: 'max-w-3xl',
  default: 'max-w-6xl',
  wide: 'max-w-screen-2xl',
};

/** The page's horizontal frame: one max width per kind of page and the shared side gutters (16px on phones). */
export function PageContainer({
  as: Tag = 'div',
  width = 'default',
  className,
  children,
  ...rest
}: PageContainerProps) {
  return (
    <Tag {...rest} className={cx('mx-auto w-full px-4 md:px-8 xl:px-12', WIDTH[width], className)}>
      {children}
    </Tag>
  );
}
